import { createRouter, createWebHistory } from 'vue-router'

// Lazy load components for better performance
const HomePage = () => import('../components/HomeComponent.vue')
const EventsComponent = () => import('../components/EventsComponent.vue')
const AboutUsComponent = () => import('../components/AboutUsComponent.vue')
const LegalPage = () => import('../components/LegalPageComponent.vue')

const routes = [
    { 
        path: '/', 
        name: 'Home', 
        component: HomePage,
        meta: {
            title: 'Mirai Motion - Culture For Generations',
            description: 'Een veilige, inclusieve plek waar de geek-community samenkomt, zichzelf kan zijn en verbinding kan zoeken.'
        }
    },
    { 
        path: '/events', 
        name: 'Events', 
        component: EventsComponent,
        meta: {
            title: 'Evenementen - Mirai Motion',
            description: 'Ontdek onze aankomende evenementen en sluit je aan bij de community!'
        }
    },
    { 
        path: '/contact', 
        name: 'Contact', 
        component: AboutUsComponent,
        meta: {
            title: 'Contact - Mirai Motion',
            description: 'Neem contact op met Mirai Motion. Deel je idee, of word partner.'
        }
    },
    {
        path: '/terms',
        name: 'Terms',
        component: LegalPage,
        meta: {
            doc: 'terms',
            title: 'Algemene voorwaarden - Mirai Motion',
            description: 'De algemene voorwaarden van Mirai Motion, voor deze website en voor onze evenementen.'
        }
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: LegalPage,
        meta: {
            doc: 'privacy',
            title: 'Privacybeleid - Mirai Motion',
            description: 'Hoe Mirai Motion omgaat met je persoonsgegevens.'
        }
    },
    // Oude adressen blijven werken: /about is hernoemd naar /contact, /news is vervallen.
    { path: '/about', redirect: '/contact' },
    { path: '/news', redirect: '/events' },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
})

// Update document title and meta tags on route change
router.beforeEach((to, from, next) => {
    // Set document title
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription && to.meta.description) {
        metaDescription.setAttribute('content', to.meta.description);
    }
    
    next();
});

export default router
